module.exports = __webpack_public_path__ + "img/clock.7e57b0f3.png";